import {
	Container, Graphics, Text, TextStyle,
} from 'pixi.js';

import Button from './ButtonSolid.js';

export default class GameOver extends Container {
	constructor(message, scorePlayer1, scorePlayer2, ...arg) {
		super(...arg);
		this.message = message || 'You win!';
		this.player1Name = 'You';
		this.player2Name = 'Computer';
		this.readyPlayer1 = false;
		this.readyPlayer2 = false;
		this.scorePlayer1 = scorePlayer1 || 0;
		this.scorePlayer2 = scorePlayer2 || 0;
		this.isForfeit = false;

		this.onClose = function () { };

		this.onRematch = function () { };

		this.onDetails = function () { };

		// this.on('pointerdown', this.close_onClick.bind(this));

		//background
		// var popupBackground = new Graphics();
		// popupBackground.beginFill(0x000000);
		// popupBackground.drawRect(-500, -500, 1000, 1000);
		// popupBackground.alpha = 0.1;
		// this.addChild(popupBackground);

		this.container = new Container();
		this.addChild(this.container);

		const styleTitle = new TextStyle({
			fontFamily: 'Arial',
			fontSize: 40 * 2,
			fill: '#FFFFFF',
			wordWrap: true,
			wordWrapWidth: 800,
			align: 'center',
		});

		//background
		const graphics = new Graphics();
		graphics.beginFill(0x333333);
		graphics.lineStyle(0, 0xFFFFFF, 1);
		// graphics.drawRect(0, 0, 500, 500);
		graphics.drawRoundedRect(0, 0, 400, 140, 10);
		// graphics.alpha = 0.5;
		this.container.addChild(graphics);

		//textTitle
		this.textTitle = new Text('You Win!', styleTitle);
		this.textTitle.x = 200;
		this.textTitle.y = 10;
		this.textTitle.anchor.set(0.5, 0);
		this.textTitle.scale.set(0.5);
		this.container.addChild(this.textTitle);

		//rematch indicator ready
		this.btnHighlightReady = new Graphics();
		this.btnHighlightReady.lineStyle(2, 0xFFFF00, 3);
		this.btnHighlightReady.drawRoundedRect(205, 70, 185, 60, 10);
		this.container.addChild(this.btnHighlightReady);

		//Next Round  button
		this.btnRematch = new Button('Rematch', 0x479ACE, 185);
		this.btnRematch.x = 100;
		this.btnRematch.y = 70;
		this.btnRematch.on('pointerdown', this.btnRematch_onClick.bind(this));
		this.container.addChild(this.btnRematch);
	}

	update() {
		this.textTitle.text = this.message;
		this.btnHighlightReady.visible = this.readyPlayer1 || this.readyPlayer2;

		if (this.isForfeit) {
			this.btnRematch.text = 'Quit';
		}
	}

	btnDetails_onClick(event) {
		//this.visible = false;
		this.parent.isDirty = true;
		event.stopPropagation();
		if (this.onDetails) {
			this.onDetails();
		}
	}

	btnRematch_onClick(event) {
		//this.visible = false;
		this.parent.isDirty = true;
		event.stopPropagation();
		if (this.onRematch) {
			this.onRematch();
		}
	}

	btnNext_onClick(event) {
		this.visible = false;
		this.parent.isDirty = true;
		// this.parent.isDirty = true;
		// this.parent.removeChild(this);
		event.stopPropagation();
		if (this.onClose) {
			this.onClose();
		}
	}

	close_onClick() {
		if (this.onClose) {
			this.onClose();
		}

		this.visible = false;
		this.parent.isDirty = true;
		//  this.parent.isDirty = true;
		//   this.parent.removeChild(this);
	}
}
